const PAT_KEY = 'GH_PAT';

export const getPat = async () => {
  return localStorage.getItem(PAT_KEY);
};

export const setPat = async (pat: string) => {
  localStorage.setItem(PAT_KEY, pat);
};
